module.exports = __webpack_public_path__ + "img/P33920580Hcamera.17f13258.jpg";